<!-- sso-invalid.component.html -->
<div class="sso-invalid-container">
  <div class="sso-invalid-card">
    <p class="sso-invalid-message">
      You have reached an invalid page.<br>
      Close this tab and return to the Apprize app.
    </p>
  </div>
</div>
